import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = () => {
  // Loading Spinner wurde entfernt - zeigt nichts an
  return null;
};

export default LoadingSpinner;
